import styled, { ColorProps, css, space, SpaceProps, typography, TypographyProps } from "../../../shared/styled";

/* eslint-disable jsx-a11y/heading-has-content */
interface IProps extends SpaceProps, ColorProps, TypographyProps {
    $tt?: string;
}

const props = [
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "color",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "lineHeight",
    "letterSpacing",
    "textAlign",
];

export const StyledHeading = styled("h6").withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) =>
        ![...props].includes(prop) && defaultValidatorFn(prop),
})<IProps>`
    ${({ $tt }) =>
        $tt &&
        css`
            text-transform: ${$tt};
        `}
    ${space};
    ${typography};
`;
